export default (): Promise<Event> => new Promise((resolve, reject) => {
  const script = document.createElement('script');

  script.id = 'duo_security';
  script.onload = resolve;
  script.onerror = reject;
  script.async = true;
  script.src = 'https://api.duosecurity.com/frame/hosted/Duo-Web-v2.min.js';

  document.head.appendChild(script);
});
